// extracted by mini-css-extract-plugin
export var button = "OverlapIsAdultConfirmation-module--button--93edb";
export var buttonNo = "OverlapIsAdultConfirmation-module--buttonNo--00e4a";
export var buttonText = "OverlapIsAdultConfirmation-module--button-text--05fa6";
export var buttons = "OverlapIsAdultConfirmation-module--buttons--fa3df";
export var content = "OverlapIsAdultConfirmation-module--content--7ff11";
export var modal = "OverlapIsAdultConfirmation-module--modal--9b386";
export var title = "OverlapIsAdultConfirmation-module--title--480f3";